import { gql } from '@apollo/client';

interface StartGlueCrawlerProps {
    datasetUri: string;
    input: any;
}

// to do add state prop to call after backend has added this to production
const startGlueCrawler = ({ datasetUri, input }: StartGlueCrawlerProps) => {
    return {
        variables: {
            datasetUri: datasetUri,
            input: input,
        },
        mutation: gql`
            mutation StartGlueCrawler(
                $datasetUri: String
                $input: CrawlerInput
            ) {
                startGlueCrawler(datasetUri: $datasetUri, input: $input) {
                    Name
                    AwsAccountId
                    region
                    status
                    state
                }
            }
        `,
    };
};

export default startGlueCrawler;
